import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams } from 'react-router-dom';

import SaleForceDetail from 'components/Tvendo/Sale/DataMaster/SaleForce/SaleForceDetail/List.js';
import SaleForceCanal from 'components/Tvendo/Sale/DataMaster/SaleForce/SaleForceCanal/List.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsGet } from 'services/WService';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();

  const themeTab = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [saleForce, setSaleForce] = useState({});
  const [sfDetails, setSFDetails] = useState([]);
  const [sfCanals, setSFCanals] = useState([]);

  async function getSaleForce() {
    let response = await wsGet('base/sale-force', id);
    if (response.success) {
      setSaleForce(response.data);
      setSFDetails(response.data.details);
      setSFCanals(response.data.canals);
    }
  }

  useEffect(() => {
    getSaleForce();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>Fuerza venta: {saleForce.base_bureau_description}</h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                <Tab label="Detalle" {...indexTab(0)} />
                <Tab label="Canal" {...indexTab(1)} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0} dir={themeTab.direction}>
                <SaleForceDetail
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  sfDetails={sfDetails}
                  reload={getSaleForce}
                />
              </TabPanel>
              <TabPanel value={value} index={1} dir={themeTab.direction}>
                <SaleForceCanal
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  sfCanals={sfCanals}
                  reload={getSaleForce}
                />
              </TabPanel>
            </SwipeableViews>
          </div>
        </Fragment>
      ) : undefined}
    </Fragment>
  );
}
